import { Badge, Box, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Event } from "../../proto/api_pb";
import { modalStyle, styles } from "./styles";
import { NotificationCard } from "./NotificationCard";
import { TrackObj } from "../../pages/MyTracks/types";

export const NotificationMenu: React.FC<{ track: TrackObj }> = ({ track }) => {
  const [allNotifications, setAllNotifications] = useState<Event[]>();
  const [isNotificationMenuOpen, setIsNotificationMenuOpen] =
    useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setAllNotifications(track.notifications);
  }, [track.notifications]);

  const updateDismiss = (id: string) => {
    const filteredNotifications = allNotifications?.filter((n) => {
      if (n.getId() !== id) {
        return n;
      }
    });
    setAllNotifications(filteredNotifications);
  };

  useEffect(() => {
    if (allNotifications?.length === 0) {
      setIsNotificationMenuOpen(false);
    }
  }, [allNotifications?.length]);

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setIsNotificationMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isNotificationMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNotificationMenuOpen]);

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Box
          ref={menuRef}
          sx={{
            ...modalStyle,
            display: isNotificationMenuOpen ? "flex" : "none",
          }}
        >
          <Box
            sx={{
              ...styles.allEventsContainer,
              ...{},
            }}
          >
            {allNotifications &&
              allNotifications.map((notification, i) => {
                return (
                  <NotificationCard
                    key={i}
                    notification={notification}
                    updateDismiss={updateDismiss}
                  />
                );
              })}
          </Box>
        </Box>
        <>
          <IconButton
            ref={buttonRef}
            onClick={() => {
              setIsNotificationMenuOpen(!isNotificationMenuOpen);
            }}
            sx={{ marginLeft: 1, marginTop: -1.3 }}
          >
            <Badge
              color="error"
              overlap="rectangular"
              badgeContent={allNotifications?.length}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiBadge-badge": {
                  borderRadius: "5px",
                },
              }}
            >
              <span></span>
            </Badge>
          </IconButton>
        </>
      </Box>
    </>
  );
};
